import axios from 'axios'

const apiClient = axios.create({
    // create single axios instance for entire app
    baseURL: '/', // base URL to call
    withCredentials: false, // this is the default
    headers: {
    // authentication and configuration
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
})

export default {
    getStores () {
        return apiClient.get(process.env.SHOPS_JSON)
    },
    getStoreByCalenderId (calenderid, timifyid) {
        let url = process.env.SHOPS_JSON + '/' + calenderid + '/' + timifyid
        return apiClient.get(url)
    },
    getStoreByID (nid) {
        let url = process.env.SHOP_BY_ID + '/' + nid
        return apiClient.get(url)
    }
}
